document.addEventListener("DOMContentLoaded", () => {
    let buttons = document.querySelectorAll('.footer__store-switcher button');

    let storeSelect = document.querySelector('.footer__store-select');
    if (storeSelect) {
        storeSelect.addEventListener('change', (e) => {
            let storeId = e.target.value;
            changeStore(storeId);
        })
    }
    if (buttons) {
        buttons.forEach((item) => {
            item.addEventListener('click', () => {
                let storeId = item.getAttribute('data-store-id');

                changeStore(storeId);
                buttons.forEach((button) => button.classList.remove('active'));
                item.classList.add('active');
            });
        })
    }
});

function changeStore(storeId) {

    let stores = document.querySelectorAll('.footer__store');
    stores.forEach((item) => {
        if (storeId != item.getAttribute('data-store-id')) {
            item.classList.add('hidden');
        } else {
            item.classList.remove('hidden');
        }
    });

    const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;
    fetch('/store/' + storeId, {
        headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
        },
        'method': 'POST'
    }).then((response) => {
        // let data = response.json();
        if (response.status === 200) {
            // location.reload();
        } else if (response.status === 500) {
            alert(response.statusText);
        } else {

        }
    })
}
